import { FC, useEffect, useState } from "react";
import { ShuttleContents } from '../../../pages/campus/shuttle';
import FileUpload from "../../FileUpload";
import { Descriptions, Select } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/rootReducer";
import Radio from '../../Radio';
import Button from '../../../components/Button';
import useNotification from "../../../hooks/useNotification";
import useAxios from "../../../hooks/useAxios";
import { createBus, updateBus } from "../../../api/shuttleSetting.api";
import Loader from "../../Loader";
import ErrorResponse from "../../ErrorResponse";
import { IBusDetail } from '../../../models/shuttleSetting.model';
import { useHistory } from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";

interface IProps {
  bus?: IBusDetail | undefined;
}

const BusEdit: FC<IProps> = ({ bus }) => {
  const { t, i18n } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // BU0001 = 차량 구분
  const BU0001 = commonCodes.find(item => item.commonCode === 'BU0001')?.detailCode;
  // SY0007 = 차량 구분
  const SY0007 = commonCodes.find(item => item.commonCode === 'SY0007')?.detailCode;
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  const [isCreate, setIsCreate] = useState(true);
  const [inputs, setInputs] = useState<any>({
    busName: '',
    busGbn: undefined,
    driverName: '',
    telephoneNo: '',
    busNo: '',
    busType: '',
    quota: '',
    useYn: 'Y',
    salaryAmt: '',
    depositor: '',
    bankCode: undefined,
    accountNo: '',
    busNote: ''
  });
  const [contractFile, setContractFile] = useState<any>();
  const [carAttachFile, setCarAttachFile] = useState<any>();
  const [imgBase64, setImgBase64] = useState('');

  useEffect(() => {
    if (bus) {
      setIsCreate(false);
      setInputs(bus);
    }
  }, [bus]);

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push(`/campus/shuttle?index=${ShuttleContents.BusList}`);
    }
  }, [res, isLoading]);

  const onSetCarAttachFile = (file: any) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      if (base64) setImgBase64(base64.toString());
    }
    reader.readAsDataURL(file);
    setCarAttachFile(file);
  }

  const onSetInputs = (key: string, value: string) => {
    setInputs({ ...inputs, [key]: value });
  }

  const onSubmit = () => {
    if (!inputs.busName) {
      return infoNotification(t('campus.shuttle.message1'));
    }
    if (!inputs.busGbn) {
      return infoNotification(t('campus.shuttle.message2'));
    }
    if (!inputs.driverName) {
      return infoNotification(t('campus.shuttle.message3'));
    }
    if (!inputs.telephoneNo) {
      return infoNotification(t('campus.shuttle.message4'));
    }
    const regex = /^\d+$/;
    if (!regex.test(inputs.telephoneNo)) {
      return infoNotification(t('campus.shuttle.message5'));
    }
    if (!inputs.busNo) {
      return infoNotification(t('campus.shuttle.message6'));
    }
    if (!inputs.busType) {
      return infoNotification(t('campus.shuttle.message7'))
    }
    if (!inputs.quota) {
      return infoNotification(t('campus.shuttle.message8'))
    }

    const form = new FormData();
    delete inputs.carAttachFile;
    delete inputs.contractFile;
    if (!inputs.carAttachFileCode || inputs.carAttachFileCode === 'null') {
      delete inputs.carAttachFileCode;
    }
    if (!inputs.contractFileCode || inputs.contractFileCode === 'null') {
      delete inputs.contractFileCode;
    }
    Object.entries(inputs).forEach((input: any) => {
      form.append(input[0], input[1])
    });

    if (isCreate) {
      // 등록
      form.append('campusCode', currentCampus);
      if (contractFile) form.append('contractFile', contractFile);
      if (carAttachFile) form.append('carAttachFile', carAttachFile);
      execute(createBus(currentCampus, form));
    } else {
      // 수정
      if (contractFile) {
        if (bus?.contractFile) {
          form.append('contractFileStatus', 'update');
        } else {
          form.append('contractFileStatus', 'new');
        }
        form.append('contractNewFile', contractFile);
      }
      if (carAttachFile) {
        if (bus?.carAttachFile) {
          form.append('carFileStatus', 'update');
        } else {
          form.append('carFileStatus', 'new');
        }
        form.append('carNewFile', carAttachFile);
      }
      if (bus) {
        execute(updateBus(currentCampus, bus.busCode, form));
      }
    }
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div>
        <div className="comm-table__area rowType">
          <div className="profile">
            <div>
              <div className="box-photo mx-auto mb-2">
                {
                  carAttachFile
                    ? imgBase64
                      ? <img className="img-preview" src={imgBase64} alt="preview" />
                      : null
                    : bus?.carAttachFile
                      ? <img className="img-preview" src={bus?.carAttachFile.fileLocation} alt="preview" />
                      : null
                }
              </div>
            </div>
            <div className="row justify-content-center">
              <FileUpload
                file={carAttachFile}
                setFile={onSetCarAttachFile}
              />
            </div>
          </div>
          <Descriptions className="w-100" bordered size="small" column={3}>
            <Descriptions.Item label={t('campus.shuttle.column1')} span={2}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.busName}
                onChange={e => onSetInputs('busName', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column4')}>
              <Select
                className="w-100"
                placeholder={t('campus.staff.placeholder2')}
                value={inputs.busGbn}
                onChange={value => onSetInputs('busGbn', value)}
              >
                {BU0001?.map(item => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {i18n.language = 'en' ? item.engName : item.korName}
                  </Select.Option>
                ))}
              </Select>
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column2')}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.driverName}
                onChange={e => onSetInputs('driverName', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column5')}>
              <input
                type="text"
                className="form-control input-text"
                placeholder={t('campus.shuttle.placeholder1')}
                value={inputs.telephoneNo}
                onChange={e => onSetInputs('telephoneNo', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column3')}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.busNo}
                onChange={e => onSetInputs('busNo', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column6')}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.busType}
                onChange={e => onSetInputs('busType', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column7')}>
              <input
                type="text"
                className="form-control input-text"
                placeholder={t('campus.shuttle.placeholder2')}
                value={inputs.quota}
                onChange={e => onSetInputs('quota', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column8')}>
              <Radio
                checked={inputs.useYn === 'Y'}
                onChange={() => onSetInputs('useYn', 'Y')}
                text={t('common.option.yes')}
              />
              <Radio
                className="ml-4"
                checked={inputs.useYn === 'N'}
                onChange={() => onSetInputs('useYn', 'N')}
                text={t('common.option.no')}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column9')}>
              {
                bus?.contractFile
                  ? (
                    <>
                      <a
                        className="download-link btn-text"
                        href={`${bus?.contractFile.fileLocation}`}
                        download={bus?.contractFile.originalName}
                      >
                        {bus?.contractFile.originalName}
                      </a>
                      <br />
                    </>
                  )
                  : null
              }
              <FileUpload
                file={contractFile}
                setFile={setContractFile}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column10')}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.salaryAmt}
                onChange={e => onSetInputs('salaryAmt', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column11')}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.depositor}
                onChange={e => onSetInputs('depositor', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column12')}>
              <Select
                className="w-100"
                placeholder={t('campus.shuttle.placeholder2')}
                value={inputs.bankCode}
                onChange={value => onSetInputs('bankCode', value)}
              >
                {SY0007?.map(item => (
                  <Select.Option
                    key={item.detailCode}
                    value={item.detailCode}
                  >
                    {i18n.language === 'en' ? item.engName : item.korName}
                  </Select.Option>
                ))}
              </Select>
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column13')} span={2}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.accountNo}
                onChange={e => onSetInputs('accountNo', e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('campus.shuttle.column14')} span={3}>
              <input
                type="text"
                className="form-control input-text"
                value={inputs.busNote}
                onChange={e => onSetInputs('busNote', e.target.value)}
              />
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area left ">
          <Button
            className="btn-basic gray-line"
            onClick={() => history.push(`/campus/shuttle?index=${ShuttleContents.BusList}`)}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={onSubmit}
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </>
  );
}

export default BusEdit;
